import { Component, OnInit, ViewChild } from '@angular/core';
import { IntegrationPartner } from 'src/app/models/ManageIntegrationModel';
import { IntegrationPartnerListComponent } from '../admin/integration-partner-list.component';
import { PlatformApiService } from 'src/app/services/platform-api.service';
import { SessionService } from 'src/app/services/session.service';

@Component({
  selector: 'app-partner-dashboard',
  templateUrl: './partner-dashboard.component.html',
  styleUrls: ['./partner-dashboard.component.scss']
})
export class PartnerDashboardComponent implements OnInit {
  state='LIST';
  selectedPartner: IntegrationPartner;

  @ViewChild(IntegrationPartnerListComponent) partnerList: IntegrationPartnerListComponent;

  constructor(private _platformApi: PlatformApiService, public _sessionService: SessionService) { }

  ngOnInit() {
  }

  showList() {
    this.selectedPartner = undefined;
    this.state = 'LIST'
  }

  onStateChange(event) {
    switch(event.state) {
      case 'CREATE':
        this.selectedPartner = new IntegrationPartner();
        this.state = 'CREATE';
        break;
      case 'SELECT':
      case 'EDIT':
        this.selectedPartner = event.item;
        this.state = 'EDIT';
        break;
      case 'CREATESUCCESS':
      case 'EDITSUCCESS':
      case 'CREATECANCEL':
      case 'EDITCANCEL':
        this.selectedPartner = undefined;
        this.state = 'LIST';
        break;
    }
  }
}
